import { useRef, useState, useEffect } from "react";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";

const options = {
  disableDefaultUI: true,
  zoomControl: false,
  panControl: false,
  rotateControl: false,
  scaleControl: false,
  streetViewControl: false,
  fullscreenControl: false,
  mapTypeControl: false,
  keyboardShortcuts: false,
  gestureHandling: "greedy",
};

const PrecisedAddressMap = ({ data, setData, setErrors }) => {
  const [center, setCenter] = useState({
    lat: 29.2266,
    lng: 47.9689,
  });
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_MAP_API_KEY,
  });
  const mapRef = useRef(null);
  const containerStyle = {
    width: "100%",
    height: "100%",
  };

  useEffect(() => {
    if (
      !isNaN(parseFloat(data?.latitude)) &&
      !isNaN(parseFloat(data?.longitude))
    ) {
      setCenter({
        lat: parseFloat(data?.latitude),
        lng: parseFloat(data?.longitude),
      });
    } else if (
      !isNaN(parseFloat(data?.street?.latitude)) &&
      !isNaN(parseFloat(data?.street?.longitude))
    ) {
      setCenter({
        lat: parseFloat(data?.street?.latitude),
        lng: parseFloat(data?.street?.longitude),
      });
    } else {
      setCenter({
        lat: 29.2266,
        lng: 47.9689,
      });
    }
  }, [data?.street, data?.latitude, data?.longitude]);

  return (
    isLoaded && (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={15}
        options={options}
        onLoad={(map) => {
          mapRef.current = map;
        }}
      >
        <Marker
          position={center}
          draggable={true}
          onDragEnd={(e) => {
            const newLat = e.latLng?.lat();
            const newLng = e.latLng?.lng();
            setData((prev) => ({
              ...prev,
              latitude: newLat,
              longitude: newLng,
            }));
            setErrors((prev) => ({ ...prev, latitude: "", longitude: "" }));
          }}
          icon={
            window.google
              ? {
                  url: `${process.env.REACT_APP_PUBLIC_URL}icons/branch.png`,
                  scaledSize: new window.google.maps.Size(50, 50),
                }
              : undefined
          }
        />
      </GoogleMap>
    )
  );
};

export default PrecisedAddressMap;
